module.exports = __webpack_public_path__ + "assets/img/4_339.925d9ad7.jpg";